import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Panel } from '../../../common/panel'
import { SelectCustom } from '../../../common/selectCustom'
import { selectRelatedCompanyIds } from '../store/slice'
import { downloadRelatedCompany, getRelatedCompanyViewBy } from '../store/thunk'
import { RelatedCompanyTable } from './RelatedCompanyTable'

const mapViewBy = {
  all: {
    label: 'companyAnalysis.ownershipAndGroup.ALL_ADDRESSES',
    value: 0,
    isI18n: true,
  },
  district: {
    label: 'companyAnalysis.ownershipAndGroup.SAME_DISTRICT',
    value: 1,
    isI18n: true,
  },
}

export const RelatedCompany = ({ organizationId }) => {
  const dispatch = useDispatch()

  const ids = useSelector(selectRelatedCompanyIds)
  const [viewBy, setViewBy] = useState(mapViewBy.all.value)

  const handleChooseViewBy = (item) => {
    if (item.value !== viewBy) {
      setViewBy(item.value)
      dispatch(
        getRelatedCompanyViewBy({
          OrganizationId: organizationId,
          ViewByType: item.value,
        }),
      )
    }
  }

  return (
    <Panel
      id="relatedCompanies"
      isI18n
      label="companyAnalysis.ownershipAndGroup.RELATED_COMPANIES"
      downloadCsv={{
        disabled: !ids.length,
        downloadFunc: () =>
          downloadRelatedCompany({
            OrganizationId: organizationId,
            ViewByType: viewBy,
          }),
      }}
      renderRightHeader={() => (
        <div className="dFlex alignItemsCenter">
          <Translate
            value="companyAnalysis.ownershipAndGroup.VIEW_BY"
            className="fw600"
          />
          <SelectCustom
            isBorderNone
            isI18n
            activeItem={Object.values(mapViewBy).find(
              (item) => item.value === viewBy,
            )}
            data={Object.values(mapViewBy)}
            chooseItem={handleChooseViewBy}
          />
        </div>
      )}
    >
      <RelatedCompanyTable />
    </Panel>
  )
}
